import React from 'react';
import { ReactProps } from '../../lib/ReactProps';

export function ConditionalRender({ render, children }: ReactProps<{ render: boolean }>) {
    return render ? <>{children}</> : null;
}
